export default "__VITE_ASSET__kokHtKEX__"